<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import _isEqual from "lodash/isEqual";
import { mapActions, mapState } from "vuex";
import firebase from "firebase/app";
const _ = require("lodash");
import moment from "moment";
import DateRangeSearch from "@/components/admin/documents/date-range-search.vue";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ConfirmDocumentDialog from "@/components/admin/automation/confirm-document-dialog.vue";
import ConfirmSingleDocumentDialog from "@/components/admin/automation/confirm-single-document-dialog.vue";
import BasicConfirmDialog from "@/components/admin/automation/basic-confirm-dialog.vue";
import ConfirmDeleteDialog from "@/components/admin/automation/confirm-delete-dialog.vue";
import DoclineFormDialog from "@/components/admin/automation/docline-form-dialog.vue";
import { INVOICE_STATUS, INVOICE_FILE_TYPE, EVENT_TYPES } from "@/libs/libConstant";
import { cloneDeep } from "lodash";
import logActivity from "@/libs/activityLogger";
import { logUserActivity, logUserActivityBatch } from "@/libs/activityUserLogger";

export default {
  name: "documents.accountspayable",
  components: {
    DateRangeSearch,
    ConfirmDocumentDialog,
    ConfirmSingleDocumentDialog,
    ConfirmDeleteDialog,
    DoclineFormDialog,
    BasicConfirmDialog,
    Admin,
  },
  data() {
    return {
      isShowDetail:
      localStorage.getItem("isShowDetail") !== null
        ? JSON.parse(localStorage.getItem("isShowDetail"))
        : true,
      ownerFilter : "",  
      vendorFilter: "",
      sortBy: "docDate", // Column to sort by
      sortDirection: "asc", // Sort direction: 'asc' or 'desc'
      vendorId: "",
      companyId: "",
      snackbar: {
        isShow: false,
        color: "",
        text: "",
      },
      purchaseInvoices: [], // Full list of purchase orders
      displayedItems: [], // Items to display on the current page
      currentPage: 1, // Current page
      itemsPerPage:
        localStorage.getItem("pageLimit") &&
        localStorage.getItem("pageLimit") === "auto"
          ? 10
          : Number.parseInt(localStorage.getItem("pageLimit")) || 10, // Items per page
      totalItems: 0, // Total number of items
      selectedItems: [], // Selected POIDs
      selectAll: false, // Select all flag
      dialogDelete: false, // Dialog for confirmation
      selectedDoc: [], // Selected Docline data (array)
      unsubscribe: null, // Listener to unsubscribe from Firestore updates
      editMode: false, // Flag to track edit mode
      isUpdating: false,
      selectedDocCopy: null,
      selectedDocIdCopy: null,
      dialogConfirmDocument: false,
      dialogConfirmDocumentOne: false,
      searchDocID: "",
      searchStatus: "SHOW_ALL",
      searchStartDate: null,
      searchEndDate: null,
      statusOptions: [
        { text: "ทั้งหมด", value: "SHOW_ALL" },
        { text: "Pending", value: INVOICE_STATUS.PENDING_APPROVAL },
        { text: "Posting", value: INVOICE_STATUS.POSTING },
        { text: "Warning", value: INVOICE_STATUS.WARNING },
        { text: "Success", value: INVOICE_STATUS.SUCCESS },
        { text: "Error", value: INVOICE_STATUS.ERROR },
      ],
      docStatusList: [
        {
          text: "New",
          value: "NEW",
          colorClass: "new-color",
        },
        {
          text: "Pending",
          value: "PENDING_APPROVAL",
          colorClass: "pending-color",
        },
        {
          text: "Posting",
          value: "CONFIRMED",
          colorClass: "posting-color",
        },
        {
          text: "Posting",
          value: "POSTING",
          colorClass: "posting-color",
        },
        {
          text: "Warning",
          value: "FAILURE",
          colorClass: "warning-color",
        },
        {
          text: "Warning",
          value: "WARNING",
          colorClass: "warning-color",
        },
        {
          text: "Error",
          value: "ERROR",
          colorClass: "error-color",
        },
        {
          text: "Success",
          value: "SUCCESS",
          colorClass: "success-color",
        },
      ],
      docToDelete: null,
      isOpenCustomDialogue: false,
      isLoadingDocs: false,
      isDoclineDialogOpen: false,
      doclineToEdit: {}, // Holds the docline being edited
      dialogRefreshDocument: false,
      doclineToEditIndex: -1,
      isEditModeDocline: false,
      isGettingDefaultVendor: false,
      isRefreshingDoc: false,
      isConfirmingDoc: false,
      companyProductType: "AP_AUTOMATION",

      // Export Dialog
      exportDialog: false,
      isExporting: false,
      menuDatePickerStart: false,
      menuDatePickerEnd: false,
      dateExportStart: null,
      dateExportEnd: null,
      exportDocStatus: "SHOW_ALL",
      exportDateMode: "all", // "all" or "range"

      // PDF Export Dialog
      exportPdfDialog: false,
      isExportingPdf: false,
      menuPdfDatePickerStart: false,
      menuPdfDatePickerEnd: false,
      datePdfExportStart: null,
      datePdfExportEnd: null,
      exportPdfDocStatus: "SHOW_ALL",
      exportPdfDateMode: "all",
      thaiFontLoaded: false,
    };
  },
  created() {
    let companyId = this.$route.params.companyId;
    if (companyId) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyId });
      this.fetchPayAcctList({ companyId: companyId });
      this.fetchExpenseList({ companyId: companyId });
      this.fetchWhtList({ companyId: companyId });
      this.fetchVatList({ companyId: companyId });
      this.$store.dispatch("companies/fetchApVendors", {
        companyId: companyId,
      });
    }
  },
  methods: {
    ...mapActions({
      fetchPayAcctList: "accountspayable/fetchPayAcctList",
      fetchExpenseList: "accountspayable/fetchExpenseList",
      fetchWhtList: "accountspayable/fetchWhtList",
      fetchVatList: "accountspayable/fetchVatList",
    }),
    showDetail() {
      this.isShowDetail = !this.isShowDetail;
    },
    buildAccountRecords(invoice) {
        const records = [];
        const recordMap = {};

        const mergeRecord = (rec) => {
          if (!rec.acctCode) return;

          // normalise
          rec.totalDebit  = Number(rec.totalDebit)  || 0;
          rec.totalCredit = Number(rec.totalCredit) || 0;

          if (recordMap[rec.acctCode] !== undefined) {
            const idx = recordMap[rec.acctCode];
            records[idx].totalDebit  += rec.totalDebit;
            records[idx].totalCredit += rec.totalCredit;
            records[idx].isPayment   = records[idx].isPayment || rec.isPayment;
          } else {
            recordMap[rec.acctCode] = records.length;
            records.push({ ...rec });
          }
        };

        // ---------- docLines ----------
        (invoice.docLine || []).forEach((l) => {
          // main expense (subtract discount if present)
          const lineTotal = Number(invoice.totalDisAmount) > 0
            ? Number(l.lineTotal) - Number(invoice.totalDisAmount)
            : Number(l.lineTotal) || 0;

          mergeRecord({
            acctCode:   l.acctCode  || "",
            acctName:   l.acctName  || "",
            totalDebit:  l.acctType == 0 ? lineTotal : 0,
            totalCredit: l.acctType == 1 ? lineTotal : 0,
          });

          // WHT leg (if any)
          if (l.whtCode) {
            mergeRecord({
              acctCode:   l.whtAcctCode || "",
              acctName:   l.whtAcctName || "",
              totalDebit:  l.acctTypeWht == 0 ? l.whtAmount : 0,
              totalCredit: l.acctTypeWht == 1 ? l.whtAmount : 0,
            });
          }

          // VAT / Tax leg
          mergeRecord({
            acctCode:   l.acctCodeTax || "",
            acctName:   l.acctNameTax || "",
            totalDebit:  l.acctType == 0 ? l.taxAmount : 0,
            totalCredit: l.acctType == 1 ? l.taxAmount : 0,
          });
        });

        // ---------- payment ----------
        if (invoice.payment) {
          const totalPay = Number(
            invoice.payment.paymentTotal ?? 0
          );
          mergeRecord({
            acctCode:   invoice.payment.paymentAcctCode || "",
            acctName:   invoice.payment.paymentAcctName || "",
            totalDebit:  invoice.payment.acctTypePayment == 0 ? totalPay : 0,
            totalCredit: invoice.payment.acctTypePayment == 1 ? totalPay : 0,
            isPayment:  true,
          });
        }

        // ---------- sort buckets ----------
        const debit   = records.filter(r => !r.isPayment && r.totalDebit  > 0)
                              .sort((a,b)=>b.totalDebit  - a.totalDebit);
        const credit  = records.filter(r => !r.isPayment && r.totalCredit > 0)
                              .sort((a,b)=>b.totalCredit - a.totalCredit);
        const payment = records.filter(r =>  r.isPayment)
                              .sort((a,b)=>{
                                const av = a.totalDebit  || a.totalCredit;
                                const bv = b.totalDebit  || b.totalCredit;
                                return bv - av;
                              });

        return [...debit, ...credit, ...payment];
    },
    storeLog({targetPath = "", targetCollectionID = "", targetDocID = "", eventType = '',  eventDetails = {}, eventDesc = "",}) {
      const companyID = this.$route.params.companyId;
      logUserActivity(companyID, this.companyProductType, targetPath, targetCollectionID, targetDocID, eventType, eventDetails, eventDesc);
    },
    storeLogBatch(eventArr = []) {
      const companyID = this.$route.params.companyId;
      logUserActivityBatch(companyID, this.companyProductType, eventArr);
    },
    async setNewDocStatus() {
      try {
        const companyID = this.$route.params.companyId;
      const purchaseInvoicesRef = fc.db
        .collection(`Companies/${companyID}/PurchaseInvoices`)
        .doc(this.selectedDoc.id);
        await purchaseInvoicesRef.set(
        {
          status: "PENDING_APPROVAL",
        },
        { merge: true }
      );
      this.isOpenCustomDialogue = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleEscKey(event) {
      // console.log("event.key::", event.key);
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.isOpenCustomDialogue = false;
      }
    },
    sortTable(column) {
      if (this.sortBy === column) {
        // Toggle sort direction if the column is the same
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        // Set the new column and default to ascending order
        this.sortBy = column;
        this.sortDirection = "asc";
      }

      // Perform sorting
      this.purchaseInvoices.sort((a, b) => {
        let result = 0;
        if (a[column] < b[column]) result = -1;
        if (a[column] > b[column]) result = 1;

        // Reverse if the direction is descending
        return this.sortDirection === "asc" ? result : -result;
      });

      // Paginate sorted items
      this.paginate();
    },
    getDocStatus(value) {
      const docStatus = this.docStatusList.find(
        (status) => status.value === value
      );
      return docStatus;
    },
    getStatusTH(status) {
      return this.getDocStatus(status)?.text;
    },
    getColorClass(status) {
      return this.getDocStatus(status)?.colorClass;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.snackbar = {
        isShow: true,
        msg: "คัดลอกเรียบร้อย",
        color: "success",
        icon: "mdi-content-copy",
      };
    },
    isInvalidValue(value) {
      return value === "N/A" || value === 0;
    },
    checkIfInvalid(doclineItem) {
      return (
        this.isInvalidValue(doclineItem.ItemCode) ||
        this.isInvalidValue(doclineItem.ItemName) ||
        this.isInvalidValue(Number(doclineItem.UnitPriceSO)) ||
        this.isInvalidValue(Number(doclineItem.TotalPriceso))
      );
    },
    deleteDocument(doc) {
      this.docToDelete = doc;
      this.dialogDelete = true;
    },
    nAformmater(value) {
      return value === "N/A" ? "" : value;
    },
    debounceInput: _.debounce(function (keyword, keywordTo) {
      this.fetchPurchaseInvoices();
    }, 1000),
    formatNum(input) {
      const num = Number(input);

      if (isNaN(num)) {
        console.error("Invalid input:", input);
        return "0.00";
      }

      return num.toFixed(2);
    },
    openConfirmDialog() {
      this.dialogConfirmDocument = true;
    },
    openConfirmOneDialog() {
      this.dialogConfirmDocumentOne = true;
    },
    openRefreshDocument() {
      this.dialogRefreshDocument = true;
    },
    toggleEditMode() {
      this.dialogConfirmDocumentOne = false;
      this.dialogConfirmDocument = false;
      if (!this.editMode) {
        // Create a deep copy of the selected document
        this.selectedDocCopy = cloneDeep(this.selectedDoc);
      } else {
        // If cancel is clicked, revert back to the deep copy
        this.selectedDoc = cloneDeep(this.selectedDocCopy);
        this.selectedDocCopy = null; // Clear the temporary copy
      }
      this.editMode = !this.editMode;
    },
    copyExternalDocId() {
      try {
        navigator.clipboard.writeText(this.selectedDoc.id);
        this.snackbar = {
          isShow: true,
          msg: "คัดลอกเรียบร้อย",
          icon: "mdi-content-copy",
          color: "success",
        };
      } catch (error) {
        console.error("Error copying external document ID:", error);
      }
    },
    openExternalFirebaseLink() {
      try {
        const hrefLink = `https://console.firebase.google.com/project/sld-etax/firestore/databases/-default-/data/~2FCompanies~2F${this.$route.params.companyId}~2FPurchaseInvoices~2F${this.selectedDoc.id}`;
        window.open(hrefLink, "_blank");
      } catch (error) {
        console.error("Error opening external Firebase link:", error);
      }
    },
    downloadExtractedText(apID) {
      console.log("apID", apID);

      fc.db
        .collection(
          `Companies/${this.companyId}/PurchaseInvoices/${apID}/ProcessLogs`
        )
        .orderBy("@timeCreate", "desc")
        .limit(1)
        .get()
        .then((snap) => {
          if (snap.empty) {
            console.log(
              "No extracted text found for Purchase Invoice ID",
              apID
            );

            this.snackbar = {
              isShow: true,
              msg: "ไม่พบข้อมูล",
              color: "error",
            };
            return;
          }

          const resData = snap.docs[0].data();
          // Choose the appropriate field based on your data structure

          const textContent = resData.invoiceText || "";

          if (!textContent) {
            console.log("No text content available to download.");
            return;
          }

          // Prepare the text content
          let fileContent = "";
          if (Array.isArray(textContent)) {
            fileContent = textContent.join("\n");
          } else if (typeof textContent === "string") {
            fileContent = textContent;
          } else {
            fileContent = JSON.stringify(textContent, null, 2);
          }

          // Create a Blob from the text content
          const blob = new Blob([fileContent], { type: "text/plain" });
          const url = URL.createObjectURL(blob);

          // Create a temporary anchor element to trigger the download
          const a = document.createElement("a");
          a.href = url;
          a.download = `AP-TXT-${apID}.txt`;
          document.body.appendChild(a);
          a.click();

          // Clean up the temporary elements and revoke the object URL
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

          console.log("Download initiated for apID", apID);
        })
        .catch((err) => {
          console.error("Error fetching extracted text:", err);
        });
    },
    downloadJson(apID) {
      console.log("apID", apID);

      fc.db
        .collection(
          `Companies/${this.companyId}/PurchaseInvoices/${apID}/ProcessLogs`
        )
        .orderBy("@timeCreate", "desc")
        .limit(1)
        .get()
        .then((snap) => {
          if (snap.empty) {
            console.log("No JSON found for Purchase Invoice ID", apID);
            this.snackbar = {
              isShow: true,
              msg: "ไม่พบข้อมูล",
              color: "error",
            };
            return;
          }

          const jsonData = snap.docs[0].data();
          // Adjust the field name based on your Firestore document structure
          const jsonOutput = jsonData.gptResponse
            ? JSON.parse(jsonData.gptResponse)?.choices[0]?.message?.content
            : "";

          if (!jsonOutput) {
            console.log("No JSON content available to download.");
            return;
          }

          let fileContent = "";

          if (typeof jsonOutput === "object") {
            // If it's already an object, stringify it
            fileContent = JSON.stringify(jsonOutput, null, 2);
          } else if (typeof jsonOutput === "string") {
            try {
              // If it's a string, try parsing and then stringifying for formatting
              const parsed = JSON.parse(jsonOutput);
              fileContent = JSON.stringify(parsed, null, 2);
            } catch (e) {
              // If parsing fails, use the string as-is
              fileContent = jsonOutput;
            }
          } else {
            // For other data types, convert to JSON string
            fileContent = JSON.stringify(jsonOutput, null, 2);
          }

          // Create a Blob from the JSON content
          const blob = new Blob([fileContent], { type: "application/json" });
          const url = URL.createObjectURL(blob);

          // Create a temporary anchor element to trigger the download
          const a = document.createElement("a");
          a.href = url;
          a.download = `AP-JSON-${apID}.json`; // Updated filename with .json extension
          document.body.appendChild(a);
          a.click();

          // Clean up the temporary elements and revoke the object URL
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

          console.log("Download initiated for apID", apID);
        })
        .catch((err) => {
          console.error("Error fetching JSON data:", err);
        });
    },
    async refreshPurchasePdfFile() {
      this.isRefreshingDoc = true;
      try {
        const companyID = this.$route.params.companyId;
        const purchaseInvoiceFilesRef = fc.db
          .collection(`Companies/${companyID}/PurchaseInvoiceFiles`)
          .doc(this.selectedDoc.fileDocRef);

        const purchaseInvoiceRef = fc.db
          .collection(`Companies/${companyID}/PurchaseInvoices`)
          .doc(this.selectedDoc.id);
        // await purchaseInvoiceRef.set(
        //   {
        //     status: "FETCHING",
        //   },
        //   { merge: true }
        // );

        await purchaseInvoiceRef.delete();

        // console.log("setFetchStatus Success");

        await fc.db.runTransaction(async (transaction) => {
          const docSnapshot = await transaction.get(purchaseInvoiceFilesRef);
          let refreshValue = docSnapshot.data().refresh || 0; // Get current 'refresh' value or default to 0
          refreshValue++;
          transaction.update(purchaseInvoiceFilesRef, {
            refresh: refreshValue,
          });
        });
        this.isRefreshingDoc = false;

        //  console.log('Refreshed the Purchase PDF File.');
      } catch (error) {
        console.error("Error updating the refresh field:", error);
        this.isRefreshingDoc = false;
      } finally {
        this.isOpenCustomDialogue = false;
        this.selectedDoc = {};
      }
    },

    exitEditMode() {
      // Clear the temporary copy and exit edit mode
      this.selectedDocCopy = null;
      this.editMode = false;
    },
    async updateDocument() {
      try {
        // Set updating to true to indicate update in progress
        this.isUpdating = true;

        let user = firebase.auth().currentUser;

        const companyID = this.$route.params.companyId;

        const docsRef = fc.db
          .collection(`Companies/${companyID}/PurchaseInvoices`)

        const isDuplicateDocId = await docsRef.where("docId", "==", this.selectedDoc.docId).where("id", "!=", this.selectedDoc.id).get();

        if(isDuplicateDocId.size > 0) {
          this.snackbar = {
            isShow: true,
            msg: "เลขที่เอกสารซ้ํา",
            color: "warning",
          };
          return;
        }          

             // totalBeforeDiscount
        // totalBeforeVat
        // totalDisAmount
        // totalTaxAmount
        // totalWhtAmount
        // Update the document in Firebase with new values

        this.selectedDoc = {
          ...this.selectedDoc,
          payment: {
            ...this.selectedDoc.payment,
            paymentTotal: this.docTotalPayment,
          },
          docTaxRefNo: this.selectedDoc.docId,
          totalBeforeDiscount: this.docTotalBeforeDis,
          totalBeforeVat: this.docTotalBeforeDis,
          docTotal: this.docTotalPayment,
          totalTaxAmount: this.docTaxAmount,
          totalWhtAmount: String(this.docWhtAmount),
          status: INVOICE_STATUS.PENDING_APPROVAL,
          timeUpdate: firebase.firestore.FieldValue.serverTimestamp(),
          timeLastUpdateBy: user.uid,
          isDuplicate: false,
          '@APTRAN_STATUS': ''
        };

            // Define fields to ignore in the diff
         // Compute the diff using the recursive function
         const diff = this.getDeepDiff(this.selectedDocCopy, this.selectedDoc);
         console.log("diff::", diff);

        const targetPath = `Companies/${companyID}/PurchaseInvoices/${this.selectedDoc.id}`;


        const docRef = fc.db.doc(targetPath);
        await docRef.set(this.selectedDoc, { merge: true });
        // Update successful
        console.log("Document updated successfully!");
        this.exitEditMode();
        this.snackbar = {
          isShow: true,
          msg: "บันทึกเอกสารเรียบร้อย",
          color: "success",
        };

        this.storeLog(
          {
            targetPath: targetPath,
            targetCollectionID: "PurchaseInvoices",
            targetDocID: this.selectedDoc.id,
            eventType: EVENT_TYPES.UPDATE,
            eventDetails: diff,
            eventDesc: "Update document",
          }
        )
        // Exit edit mode
      } catch (error) {
        this.snackbar = {
          isShow: true,
          msg: "เกิดข้อผิดพลาดในการบันทึกเอกสาร",
          color: "error",
        };

        console.error("Error updating document: ", error);
      } finally {
        // Set updating to false regardless of success or failure
        this.editMode = false;
        this.isUpdating = false;
        // this.isOpenCustomDialogue = false;
      }
    },
    async confirmDocument() {
  const uid = firebase.auth().currentUser.uid;
  const companyID = this.$route.params.companyId;

  // Filter the purchase invoices eligible for confirmation
  const docsToConfirm = this.purchaseInvoices.filter(
    (po) =>
      this.selectedItems.includes(po.id) &&
      po.status === INVOICE_STATUS.PENDING_APPROVAL
  );

  if (docsToConfirm.length === 0) {
    console.log("No documents are eligible for confirmation.");
    return;
  }

  // Create a Firestore batch
  const batch = fc.db.batch();

  // this.storeLog(
  //         {
  //           targetPath: targetPath,
  //           targetDocID: id,
  //           eventType: EVENT_TYPES.DELETE,
  //           eventDetails: {},
  //           eventDesc: "Delete document",
  //         }
  //       );

  const logArr = []

  docsToConfirm.forEach((selectedDoc) => {
    const docRef = fc.db
      .collection(`Companies/${companyID}/PurchaseInvoices`)
      .doc(selectedDoc.id);
    batch.set(
      docRef,
      {
        status: INVOICE_STATUS.POSTING,
        owner: uid,
        timeUpdate: firebase.firestore.FieldValue.serverTimestamp(),
      },
      { merge: true }
    );

    logArr.push({
      targetPath: `Companies/${companyID}/PurchaseInvoices/${selectedDoc.id}`,
      targetCollectionID: "PurchaseInvoices",
      targetDocID: selectedDoc.id,
      eventType: EVENT_TYPES.APPROVE,
      eventDetails: {},
      eventDesc: "Confirm document",
    })

  });

  try {
    // Commit the entire batch
    await batch.commit();
    console.log(
      "All documents confirmed successfully:",
      docsToConfirm.map((doc) => doc.id)
    );

    this.storeLogBatch(logArr)

  } catch (error) {
    console.error("Error confirming documents:", error);
  } finally {
    // Reset UI state after updating
    this.selectedItems = [];
    this.dialogConfirmDocument = false;
    this.selectAll = false;
    this.isOpenCustomDialogue = false;
  }

  // Refresh the list to reflect the changes
  this.fetchPurchaseInvoices();
},
    async confirmDocumentOne() {
      this.isConfirmingDoc = true;
      const companyID = this.$route.params.companyId;

      // If there are no documents to confirm, return early

      // Iterate over each document eligible for confirmation
      const targetPath = `Companies/${companyID}/PurchaseInvoices/${this.selectedDoc.id}`;
      const purchaseOrdersRef = fc.db.doc(targetPath);

      const uid = firebase.auth().currentUser.uid;

      try {
        // Update the status of the current document to "CONFIRMED"
        await purchaseOrdersRef.set(
          {
            status: INVOICE_STATUS.POSTING,
            owner: uid,
            timeUpdate: firebase.firestore.FieldValue.serverTimestamp(),
          },
          { merge: true }
        );
        console.log(
          `Document with id ${this.selectedDoc.id} confirmed successfully.`
        );

        this.snackbar = {
          isShow: true,
          msg: "ยืนยันเอกสารเรียบร้อยแล้ว",
          color: "success",
        };

        this.storeLog(
          {
            targetPath: targetPath,
            targetCollectionID: "PurchaseInvoices",
            targetDocID: this.selectedDoc.id,
            eventType: EVENT_TYPES.APPROVE,
            eventDetails: {},
            eventDesc: "Approve document",
          }
        )

      } catch (error) {
        console.error(
          `Error confirming document with id ${this.selectedDoc.id}:`,
          error
        );

        this.snackbar = {
          isShow: true,
          msg: "เกิดข้อผิดพลาดในการยืนยันเอกสาร",
          color: "error",
        };

      } finally {
        this.selectedDoc = {};
        this.dialogConfirmDocumentOne = false;
        this.isOpenCustomDialogue = false;
        this.isConfirmingDoc = false;
      }

      // Fetch purchase orders to reflect the changes
      this.fetchPurchaseInvoices();

      // Close the confirmation dialog
      this.isOpenCustomDialogue = false;
    },
    async fetchPurchaseInvoices() {
      this.isLoadingDocs = true;
      try {
        const { searchDocID, searchStatus, searchStartDate, searchEndDate } =
          this;

        const defaultStatusList = [
          "SUCCESS",
          "FAILURE",
          "CONFIRMED",
          "PENDING_APPROVAL",
          "POSTING",
          "WARNING",
          "ERROR",
        ];

        const companyID = this.$route.params.companyId;

        let query = fc.db.collection(`Companies/${companyID}/PurchaseInvoices`);

        const orderByFields = [];

        // Filter by POID
        if (searchDocID) {
          query = query.where("docId", "==", searchDocID);
          orderByFields.push("docId");
        }

        const statusList =
          !searchStatus || searchStatus === "SHOW_ALL"
            ? defaultStatusList
            : searchStatus === INVOICE_STATUS.WARNING
              ? [INVOICE_STATUS.WARNING, INVOICE_STATUS.FAILURE]
              : [searchStatus];

        query = query.where("status", "in", statusList);
        orderByFields.push("status");

        // Filter by docDate
        if (searchStartDate) {
          const start = new Date(searchStartDate);
          start.setHours(0);

          const end = searchEndDate
            ? new Date(searchEndDate)
            : new Date(searchStartDate);
          end.setHours(23, 59, 59, 999);

          query = query.where("docDate", ">=", start);
          query = query.where("docDate", "<=", end);
        }
        orderByFields.unshift("docDate");

        // Apply orderBy clauses in sequence
        orderByFields.forEach((field) => {
          query = query.orderBy(field, field === "docDate" ? "desc" : "asc");
        });

        if (this.unsubscribe) {
          this.unsubscribe();
        }
        this.unsubscribe = query.onSnapshot((snapshot) => {
          this.purchaseInvoices = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          this.totalItems = this.purchaseInvoices.length;
          // Do not reset currentPage here
          this.paginate(); // Update pagination based on the new data
          this.isLoadingDocs = false;
        });
      } catch (error) {
        console.error("Error fetching purchase orders:", error);
        this.isLoadingDocs = false;
      }
    },
    paginate() {
  let source = this.purchaseInvoices;

  // ── vendor filter ─────────────────────────────
  if (this.vendorFilter && this.vendorFilter.trim() !== "") {
    const term = this.vendorFilter.toLowerCase();
    source = source.filter(
      inv =>
        (inv.cardCode && inv.cardCode.toLowerCase().includes(term)) ||
        (inv.cardName && inv.cardName.toLowerCase().includes(term))
    );
  }

  // ── owner filter ──────────────────────────────
  if (this.ownerFilter && this.ownerFilter.trim() !== "") {
    const term = this.ownerFilter.toLowerCase();
    source = source.filter(
      inv =>
        (inv.owner     && inv.owner.toLowerCase().includes(term)) ||
        (inv.ownerName && inv.ownerName.toLowerCase().includes(term))
    );
  }

  // ── paginate ─────────────────────────────────
  this.totalItems = source.length;
  const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
  if (this.currentPage > totalPages) {
    this.currentPage = totalPages || 1;
  }

  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex   = startIndex + this.itemsPerPage;
  this.displayedItems = source.slice(startIndex, endIndex);

  this.selectedItems = [];
  this.selectAll     = false;
},

    toggleAll() {
      if (this.selectAll) {
        this.selectedItems = this.displayedItems.map((item) => item.id);
      } else {
        this.selectedItems = [];
      }
    },
    getCheckboxValue(item) {
      return `${item.id}`;
    },
    handleStatusSearch() {
      this.fetchPurchaseInvoices(this.searchKeywords);
      // console.log("Search status", this.searchKeywords);
    },
    confirmDelete() {
      this.dialogDelete = true;
    },
    async deleteSelectedItems() {
      // Delete selected items by their POIDs
      // console.log("this.docToDelete:: ", this.docToDelete.id);
      const id = this.docToDelete.id;
      try {
        const companyID = this.$route.params.companyId;
        const targetPath = `Companies/${companyID}/PurchaseInvoices/${id}`;
        await fc.db
          .doc(targetPath)
          .set(
            {
              status: "DELETED",
            },
            { merge: true }
          );


          this.storeLog(
          {
            targetPath: targetPath,
            targetCollectionID: "PurchaseInvoices",
            targetDocID: id,
            eventType: EVENT_TYPES.DELETE,
            eventDetails: {},
            eventDesc: "Delete document",
          }
        )

      } catch (error) {
        console.error(`Error deleting item with id ${id}:`, error);
      }
      // After deletion, clear selected items
      // No need to refetch data, as it updates in real-time
      // Close the confirmation dialog
      this.dialogDelete = false;
    },
    // Method to show Docline details dialog
    showDocDetailDialog(doc) {
      this.isOpenCustomDialogue = true;
      this.selectedDoc = cloneDeep(doc);
      this.selectedDocIdCopy = this.selectedDoc.docId
    },
    resetSearchConfig() {
      this.searchDocID = "";
      this.searchStatus = "SHOW_ALL";
      this.searchStartDate = null;
      this.searchEndDate = null;
    },
    getThaiDate(timestamp) {
      if (!timestamp) return "N/A";
      moment.locale("th");
      const date = new Date(timestamp.seconds * 1000);
      // Format the date with Thai month and Buddhist year
      const formattedDate = moment(date).add(543, "years").format("DD MMM YY");
      return formattedDate;
    },
    async fetchPurchaseInvoicesByDateRange(fromDate, toDate) {
      console.log("fromDate::", fromDate);
      console.log("toDate::", toDate);
      this.searchStartDate = fromDate;
      this.searchEndDate = toDate;
      await this.fetchPurchaseInvoices();
    },
    resetDateSearch() {
      this.resetSearchConfig();
      this.fetchPurchaseInvoices();
    },
    getItemTotalDebit(item) {
      return (item.accountRecords || []).reduce((sum, r) => sum + (Number(r.totalDebit) || 0), 0);
    },
    getItemTotalCredit(item) {
      return (item.accountRecords || []).reduce((sum, r) => sum + (Number(r.totalCredit) || 0), 0);
    },
    isDebitCreditBalanced(item) {
      return Math.abs(this.getItemTotalDebit(item) - this.getItemTotalCredit(item)) < 0.01;
    },
    cancelExportDocs() {
      this.exportDialog = false;
      this.dateExportEnd = "";
      this.dateExportStart = "";
      this.exportDocStatus = "SHOW_ALL";
      this.exportDateMode = "all";
    },
    getExportData() {
      // Get data based on exportDateMode
      let data = [...this.purchaseInvoices];

      if (this.exportDateMode === "range") {
        const startDate = new Date(this.dateExportStart);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(this.dateExportEnd);
        endDate.setHours(23, 59, 59, 999);

        data = data.filter((inv) => {
          const docDate = inv.docDate?.seconds
            ? new Date(inv.docDate.seconds * 1000)
            : new Date(inv.docDate);
          return docDate >= startDate && docDate <= endDate;
        });
      }

      // Filter by status
      const status = this.exportDocStatus;
      if (status && status !== "SHOW_ALL") {
        data = data.filter((inv) => inv.status === status);
      }

      return data;
    },
    formatExportDate(timestamp) {
      if (!timestamp) return "-";
      const date = timestamp.seconds
        ? new Date(timestamp.seconds * 1000)
        : new Date(timestamp);
      return moment(date).format("DD/MM/YYYY");
    },
    async exportDocs() {
      if (this.exportDateMode === "range") {
        if (!this.dateExportStart || !this.dateExportEnd) {
          this.snackbar = {
            isShow: true,
            msg: "กรุณาเลือกวันที่เริ่มต้นและสิ้นสุด",
            color: "error",
          };
          return;
        }
        if (new Date(this.dateExportStart) > new Date(this.dateExportEnd)) {
          this.snackbar = {
            isShow: true,
            msg: "วันที่เริ่มต้นต้องน้อยกว่าวันที่สิ้นสุด",
            color: "error",
          };
          return;
        }
      }

      const data = this.getExportData();
      if (data.length === 0) {
        this.snackbar = {
          isShow: true,
          msg: "ไม่พบข้อมูลที่ต้องการส่งออก",
          color: "error",
        };
        return;
      }

      this.isExporting = true;
      try {
        this.exportToExcel(data);
        this.exportDialog = false;
      } catch (error) {
        console.error("Export error:", error);
        this.snackbar = {
          isShow: true,
          msg: "เกิดข้อผิดพลาดในการส่งออก",
          color: "error",
        };
      } finally {
        this.isExporting = false;
      }
    },
    exportToExcel(data) {
      const rows = [];

      data.forEach((inv, idx) => {
        const accountRecords = this.buildAccountRecords(inv);

        // Main row
        const mainRow = {
          "ลำดับ": idx + 1,
          "เลขที่เอกสาร": inv.invoiceNo || "-",
          "วันที่เอกสาร": this.formatExportDate(inv.docDate),
          "ชื่อผู้จำหน่าย": inv.cardName || "-",
          "เลขที่เอกสารจากผู้จำหน่าย": inv.docId || "-",
          "มูลค่าสินค้า": Number(inv.totalBeforeDiscount) || 0,
          "VAT": Number(inv.totalTaxAmount) || 0,
          "รวมทั้งสิ้น": Number(inv.docTotal) || 0,
          "WHT": Number(inv.totalWhtAmount) || 0,
          "Remark": inv.remark || "",
          "สถานะ": this.getStatusTH(inv.status) || inv.status,
          "รหัสบัญชี": "",
          "ชื่อบัญชี": "",
          "Debit": "",
          "Credit": "",
        };
        rows.push(mainRow);

        // Account record sub-rows
        accountRecords.forEach((record) => {
          rows.push({
            "ลำดับ": "",
            "เลขที่เอกสาร": "",
            "วันที่เอกสาร": "",
            "ชื่อผู้จำหน่าย": "",
            "เลขที่เอกสารจากผู้จำหน่าย": "",
            "มูลค่าสินค้า": "",
            "VAT": "",
            "รวมทั้งสิ้น": "",
            "WHT": "",
            "Remark": "",
            "สถานะ": "",
            "รหัสบัญชี": record.acctCode || "",
            "ชื่อบัญชี": record.acctName || "",
            "Debit": Number(record.totalDebit) || 0,
            "Credit": Number(record.totalCredit) || 0,
          });
        });
      });

      const worksheet = XLSX.utils.json_to_sheet(rows);

      // Set column widths
      worksheet["!cols"] = [
        { wch: 6 },   // ลำดับ
        { wch: 18 },  // เลขที่เอกสาร
        { wch: 14 },  // วันที่เอกสาร
        { wch: 30 },  // ชื่อผู้จำหน่าย
        { wch: 25 },  // เลขที่เอกสารจากผู้จำหน่าย
        { wch: 15 },  // มูลค่าสินค้า
        { wch: 12 },  // VAT
        { wch: 15 },  // รวมทั้งสิ้น
        { wch: 12 },  // WHT
        { wch: 20 },  // Remark
        { wch: 12 },  // สถานะ
        { wch: 15 },  // รหัสบัญชี
        { wch: 25 },  // ชื่อบัญชี
        { wch: 15 },  // Debit
        { wch: 15 },  // Credit
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "รายงานภาษี");

      const dateStr = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(workbook, `AcctsTaxReport_${dateStr}.xlsx`);
    },
    cancelExportPdf() {
      this.exportPdfDialog = false;
      this.datePdfExportEnd = "";
      this.datePdfExportStart = "";
      this.exportPdfDocStatus = "SHOW_ALL";
      this.exportPdfDateMode = "all";
    },
    getPdfExportData() {
      let data = [...this.purchaseInvoices];

      if (this.exportPdfDateMode === "range") {
        const startDate = new Date(this.datePdfExportStart);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(this.datePdfExportEnd);
        endDate.setHours(23, 59, 59, 999);

        data = data.filter((inv) => {
          const docDate = inv.docDate?.seconds
            ? new Date(inv.docDate.seconds * 1000)
            : new Date(inv.docDate);
          return docDate >= startDate && docDate <= endDate;
        });
      }

      const status = this.exportPdfDocStatus;
      if (status && status !== "SHOW_ALL") {
        data = data.filter((inv) => inv.status === status);
      }

      return data;
    },
    async loadThaiFont(doc) {
      if (this.thaiFontLoaded) return;
      try {
        const response = await fetch("/fonts/THSarabunNew.ttf");
        const arrayBuffer = await response.arrayBuffer();
        const base64 = btoa(
          new Uint8Array(arrayBuffer).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        );
        doc.addFileToVFS("THSarabunNew.ttf", base64);
        doc.addFont("THSarabunNew.ttf", "THSarabunNew", "normal");

        const responseBold = await fetch("/fonts/THSarabunNew-Bold.ttf");
        const arrayBufferBold = await responseBold.arrayBuffer();
        const base64Bold = btoa(
          new Uint8Array(arrayBufferBold).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        );
        doc.addFileToVFS("THSarabunNew-Bold.ttf", base64Bold);
        doc.addFont("THSarabunNew-Bold.ttf", "THSarabunNew", "bold");
      } catch (e) {
        console.error("Failed to load Thai font:", e);
      }
    },
    async exportPdf() {
      if (this.exportPdfDateMode === "range") {
        if (!this.datePdfExportStart || !this.datePdfExportEnd) {
          this.snackbar = {
            isShow: true,
            msg: "กรุณาเลือกวันที่เริ่มต้นและสิ้นสุด",
            color: "error",
          };
          return;
        }
        if (new Date(this.datePdfExportStart) > new Date(this.datePdfExportEnd)) {
          this.snackbar = {
            isShow: true,
            msg: "วันที่เริ่มต้นต้องน้อยกว่าวันที่สิ้นสุด",
            color: "error",
          };
          return;
        }
      }

      const data = this.getPdfExportData();
      if (data.length === 0) {
        this.snackbar = {
          isShow: true,
          msg: "ไม่พบข้อมูลที่ต้องการส่งออก",
          color: "error",
        };
        return;
      }

      this.isExportingPdf = true;
      try {
        await this.exportToPdf(data);
        this.exportPdfDialog = false;
      } catch (error) {
        console.error("PDF Export error:", error);
        this.snackbar = {
          isShow: true,
          msg: "เกิดข้อผิดพลาดในการส่งออก PDF",
          color: "error",
        };
      } finally {
        this.isExportingPdf = false;
      }
    },
    formatNumber(val) {
      const num = Number(val) || 0;
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async exportToPdf(data) {
      const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });

      await this.loadThaiFont(doc);
      doc.setFont("THSarabunNew", "normal");

      // Title
      doc.setFontSize(18);
      doc.setFont("THSarabunNew", "bold");
      doc.text("รายงานภาษี (Accounts Tax Report)", 148, 15, { align: "center" });

      // Date info
      doc.setFontSize(12);
      doc.setFont("THSarabunNew", "normal");
      const dateStr = moment().format("DD/MM/YYYY HH:mm");
      doc.text(`วันที่ส่งออก: ${dateStr}`, 148, 22, { align: "center" });

      if (this.exportPdfDateMode === "range") {
        doc.text(
          `ช่วงเวลา: ${this.datePdfExportStart} ถึง ${this.datePdfExportEnd}`,
          148,
          27,
          { align: "center" }
        );
      }

      // Build table body
      const body = [];
      let sumBeforeDiscount = 0;
      let sumTaxAmount = 0;
      let sumDocTotal = 0;
      let sumWhtAmount = 0;

      data.forEach((inv, idx) => {
        const accountRecords = this.buildAccountRecords(inv);

        // Sum for grand total
        sumBeforeDiscount += Number(inv.totalBeforeDiscount) || 0;
        sumTaxAmount += Number(inv.totalTaxAmount) || 0;
        sumDocTotal += Number(inv.docTotal) || 0;
        sumWhtAmount += Number(inv.totalWhtAmount) || 0;

        // Sum debit/credit per invoice
        let totalDebit = 0;
        let totalCredit = 0;
        accountRecords.forEach((r) => {
          totalDebit += Number(r.totalDebit) || 0;
          totalCredit += Number(r.totalCredit) || 0;
        });
        const isBalanced = Math.abs(totalDebit - totalCredit) < 0.01;

        body.push([
          { content: idx + 1, styles: { halign: "center" } },
          inv.invoiceNo || "-",
          this.formatExportDate(inv.docDate),
          inv.cardName || "-",
          inv.docId || "-",
          { content: this.formatNumber(inv.totalBeforeDiscount), styles: { halign: "right" } },
          { content: this.formatNumber(inv.totalTaxAmount), styles: { halign: "right" } },
          { content: this.formatNumber(inv.docTotal), styles: { halign: "right" } },
          { content: this.formatNumber(inv.totalWhtAmount), styles: { halign: "right" } },
          inv.remark || "",
          this.getStatusTH(inv.status) || inv.status,
        ]);

        accountRecords.forEach((record) => {
          const acctLabel = [record.acctCode, record.acctName].filter(Boolean).join(" - ");
          body.push([
            "",
            "",
            "",
            acctLabel,
            "",
            { content: record.totalDebit ? this.formatNumber(record.totalDebit) : "", styles: { halign: "right" } },
            "",
            { content: record.totalCredit ? this.formatNumber(record.totalCredit) : "", styles: { halign: "right" } },
            "",
            "",
            "",
          ]);
        });

        // Sum row for each invoice
        const sumRowStyle = { fillColor: [220, 220, 220], fontStyle: "bold" };
        const sumDebitStyle = isBalanced
          ? { ...sumRowStyle, halign: "right" }
          : { ...sumRowStyle, halign: "right", textColor: [220, 30, 30] };
        const sumCreditStyle = isBalanced
          ? { ...sumRowStyle, halign: "right" }
          : { ...sumRowStyle, halign: "right", textColor: [220, 30, 30] };
        body.push([
          { content: "", styles: sumRowStyle },
          { content: "", styles: sumRowStyle },
          { content: "", styles: sumRowStyle },
          { content: "รวม Debit / Credit", styles: { ...sumRowStyle, halign: "right" } },
          { content: "", styles: sumRowStyle },
          { content: this.formatNumber(totalDebit), styles: sumDebitStyle },
          { content: "", styles: sumRowStyle },
          { content: this.formatNumber(totalCredit), styles: sumCreditStyle },
          { content: "", styles: sumRowStyle },
          { content: "", styles: sumRowStyle },
          { content: "", styles: sumRowStyle },
        ]);
      });

      // Grand total sum debit/credit
      let grandTotalDebit = 0;
      let grandTotalCredit = 0;
      data.forEach((inv) => {
        const records = this.buildAccountRecords(inv);
        records.forEach((r) => {
          grandTotalDebit += Number(r.totalDebit) || 0;
          grandTotalCredit += Number(r.totalCredit) || 0;
        });
      });
      const isGrandBalanced = Math.abs(grandTotalDebit - grandTotalCredit) < 0.01;
      const grandMismatchStyle = { halign: "right", fontStyle: "bold", fontSize: 12, fillColor: [235, 235, 235], textColor: [220, 30, 30] };

      // Grand total row
      const totalStyle = { halign: "right", fontStyle: "bold", fontSize: 11, fillColor: [200, 200, 200], overflow: "visible" };
      body.push([
        { content: "รวมทั้งหมด", colSpan: 5, styles: { ...totalStyle, halign: "center", fontSize: 12 } },
        { content: this.formatNumber(sumBeforeDiscount), styles: totalStyle },
        { content: this.formatNumber(sumTaxAmount), styles: totalStyle },
        { content: this.formatNumber(sumDocTotal), styles: totalStyle },
        { content: this.formatNumber(sumWhtAmount), styles: totalStyle },
        { content: "", styles: { fillColor: [200, 200, 200] } },
        { content: "", styles: { fillColor: [200, 200, 200] } },
      ]);

      // Grand total Debit / Credit row
      const grandDcStyle = { halign: "right", fontStyle: "bold", fontSize: 12, fillColor: [200, 200, 200] };
      const grandDcMismatch = { ...grandDcStyle, textColor: [220, 30, 30] };
      body.push([
        { content: "", styles: { fillColor: [200, 200, 200] } },
        { content: "", styles: { fillColor: [200, 200, 200] } },
        { content: "", styles: { fillColor: [200, 200, 200] } },
        { content: "รวม Debit / Credit ทั้งหมด", styles: { ...grandDcStyle, halign: "right" } },
        { content: "", styles: { fillColor: [200, 200, 200] } },
        { content: this.formatNumber(grandTotalDebit), styles: isGrandBalanced ? grandDcStyle : grandDcMismatch },
        { content: "", styles: { fillColor: [200, 200, 200] } },
        { content: this.formatNumber(grandTotalCredit), styles: isGrandBalanced ? grandDcStyle : grandDcMismatch },
        { content: "", styles: { fillColor: [200, 200, 200] } },
        { content: "", styles: { fillColor: [200, 200, 200] } },
        { content: "", styles: { fillColor: [200, 200, 200] } },
      ]);

      doc.autoTable({
        startY: this.exportPdfDateMode === "range" ? 31 : 26,
        head: [[
          "ลำดับ",
          "เลขที่เอกสาร",
          "วันที่เอกสาร",
          "ชื่อผู้จำหน่าย",
          "เลขที่เอกสาร",
          "มูลค่าสินค้า",
          "VAT",
          "รวมทั้งสิ้น",
          "WHT",
          "Remark",
          "สถานะ",
        ]],
        body: body,
        styles: {
          font: "THSarabunNew",
          fontStyle: "normal",
          fontSize: 12,
          textColor: [0, 0, 0],
          cellPadding: 1.5,
        },
        headStyles: {
          fillColor: [52, 73, 94],
          textColor: 255,
          fontStyle: "bold",
          halign: "center",
          fontSize: 12,
          cellPadding: 2,
        },
        columnStyles: {
          0: { cellWidth: 12, halign: "center" },
          1: { cellWidth: 22 },
          2: { cellWidth: 18 },
          3: { cellWidth: 62 },
          4: { cellWidth: 28 },
          5: { cellWidth: 22, halign: "right" },
          6: { cellWidth: 18, halign: "right" },
          7: { cellWidth: 22, halign: "right" },
          8: { cellWidth: 16, halign: "right" },
          9: { cellWidth: "auto", overflow: "linebreak" },
          10: { cellWidth: 14 },
        },
        margin: { top: 10, left: 5, right: 5 },
      });

      // Add page numbers after all pages are generated
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(14);
        doc.setFont("THSarabunNew", "bold");
        doc.text(
          `หน้า ${i} / ${pageCount}`,
          doc.internal.pageSize.getWidth() - 15,
          doc.internal.pageSize.getHeight() - 7,
          { align: "right" }
        );
      }

      const exportDateStr = new Date().toISOString().slice(0, 10);
      doc.save(`AcctsTaxReport_${exportDateStr}.pdf`);
    },
    intPage() {
      this.vendorId = this.$route.params?.vendorId || "";
      this.companyId = this.$route.params?.companyId || "";

      this.$store.dispatch("companies/getCompanyProductList", {
        companyId: this.companyId,
      });
    },
    formattedText(item) {
      return `${item.paymentCode} - ${item.paymentName}`;
    },
    updatePaymentMethod(newValue) {
      const payment = this.payAcctList.find(
        (item) => item.payCode === newValue
      );

      this.selectedDoc.payment.paymentAcctCode = newValue;
      console.log("payment:: ", payment);
      if (payment) {
        this.selectedDoc.payment.paymentAcctName = payment?.payName || "";
        this.selectedDoc.payment.acctTypePayment = payment?.tranType || "";
      }
      // อัปเดตข้อมูลอื่น ๆ ตามความจำเป็น
    },
    updateCurrency(newValue) {
      this.selectedDoc.payment.currency = newValue;
    },
    handleMouseMove(event) {
      const rect = event.target.getBoundingClientRect();

      // Calculate percentage positions relative to the element's boundaries
      const x = ((event.clientX - rect.left) / rect.width) * 125;
      const y = ((event.clientY - rect.top) / rect.height) * 125;

      // Clamp the values between 0 and 100 to avoid glitches
      this.mouseX = Math.max(0, Math.min(100, x));
      this.mouseY = Math.max(0, Math.min(100, y));

      this.isZoomed = true;
    },
    handleMouseLeave() {
      this.isZoomed = false;
    },
    async openAddDoclineDialog() {
      await this.getDefaultValueFromVendor(this.selectedDoc.cardCode);
      // this.doclineToEdit = {}; // Ensure it's in add mode

      this.doclineToEditIndex = -1;
      this.isEditModeDocline = false;
      this.isDoclineDialogOpen = true;
    },
    async getDefaultValueFromVendor(cardCode) {
      this.isGettingDefaultVendor = true;

      await fc.db
        .collection(
          `Companies/${this.$route.params.companyId}/PurchaseInvoiceVendors/`
        )
        .doc(`${cardCode}`)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const docData = doc.data();

            this.doclineToEdit = {
              expenseCode: docData.defaultAcctP07?.expData?.expCode || "",
              expenseName: docData.defaultAcctP07?.expData?.expName || "",
              acctCode: docData.defaultAcctP07?.expData?.acctCode || "",
              acctName: docData.defaultAcctP07?.expData?.acctName || "",
              taxCode: docData.defaultAcctP07?.vatData?.vatCode || "",
              whtCode: docData.defaultAcctP07?.whtData?.whtCode || "",
              whtRate: docData.defaultAcctP07?.whtData?.whtRate || "",
            };
          } else {
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });

      this.isGettingDefaultVendor = false;
    },
    openEditDoclineDialog(docline, doclineIndex) {
      this.doclineToEdit = cloneDeep(docline); // Deep copy here
      this.doclineToEditIndex = doclineIndex;
      this.isEditModeDocline = true;
      this.isDoclineDialogOpen = true;
    },
    // Method to handle saving a docline (both add and edit)
    async handleSaveDocline(docline) {
      try {
        if (this.doclineToEditIndex !== -1) {
          // Update the specific docline
          // Directly replace the object in the array
          this.selectedDoc.docLine.splice(this.doclineToEditIndex, 1, docline);
        } else {
          // Adding new docline
          this.selectedDoc.docLine.push(docline);
        }
      } catch (error) {
        console.error("Error saving docline:", error);
        this.snackbar = {
          isShow: true,
          msg: "เกิดข้อผิดพลาด บันทึกไม่สําเร็จ",
          color: "error",
        };
      }
    },

    // Method to handle deleting a docline
    async handleDeleteDocline(doclineIndex) {
      try {
        console.log("deleted docline:: ", doclineIndex);
        this.selectedDoc.docLine.splice(doclineIndex, 1);
      } catch (error) {
        console.error("Error deleting docline:", error);
      }
    },
    generateUUIDv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
     // Helper to check if a value is numeric.
  isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  },

  // Recursive diff function that normalizes undefined to an empty string
  // and compares numeric values by their numeric equivalence.
  getDeepDiff(oldObj, newObj) {
    // Helper to replace undefined with empty string
    const normalize = (value) => (value === undefined ? "" : value);

    // Base case: if not both objects (or one is null), compare as primitives.
    if (
      typeof oldObj !== "object" ||
      oldObj === null ||
      typeof newObj !== "object" ||
      newObj === null
    ) {
      const normOld = normalize(oldObj);
      const normNew = normalize(newObj);

      // If both are numeric (or numeric strings), compare them as numbers.
      if (this.isNumeric(normOld) && this.isNumeric(normNew)) {
        if (Number(normOld) === Number(normNew)) {
          return {};
        }
      } else if (_.isEqual(normOld, normNew)) {
        return {};
      }
      return { old: normOld, new: normNew };
    }

    // If both values are arrays, compare them element by element.
    if (Array.isArray(oldObj) && Array.isArray(newObj)) {
      if (oldObj.length !== newObj.length) {
        return { old: normalize(oldObj), new: normalize(newObj) };
      }
      const arrDiff = [];
      for (let i = 0; i < oldObj.length; i++) {
        const diff = this.getDeepDiff(oldObj[i], newObj[i]);
        arrDiff.push(diff);
      }
      // If every element's diff is empty, then there's no diff.
      if (arrDiff.every((item) => Object.keys(item).length === 0)) {
        return {};
      }
      return arrDiff;
    }

    // For objects, compare each key.
    // Define fields to ignore in the diff.
    const ignoreFields = ["@APTRAN_STATUS", "timeCreate", "timeUpdate", "timeLastUpdateBy"];
    const diff = {};
    const keys = new Set([...Object.keys(oldObj), ...Object.keys(newObj)]);
      keys.forEach((key) => {
        if (ignoreFields.includes(key)) return;
        const subDiff = this.getDeepDiff(oldObj[key], newObj[key]);
        if (Object.keys(subDiff).length > 0) {
          diff[key] = subDiff;
        }
      });
      return diff;
    },
  },
  computed: {
    ...mapState({
      selectedCompanyAutoDocConfig: (state) =>
        state.companies.selectedCompanyAutoDocConfig,
      user: (state) => state.user.userData,
      userCompany: (state) => state.user.userCompany,
      selectedCompanyApVendors: (state) =>
        state.companies.selectedCompanyApVendors,
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading,
      payAcctList: (state) => state.accountspayable.payAcctList,
      expenseList: (state) => state.accountspayable.expenseList,
      whtList: (state) => state.accountspayable.whtList,
      vatList: (state) => state.accountspayable.vatList,
    }),
    vendorOptionsFromDisplay() {
      // Grab the first matching name so we don't loop twice
      const map = {};
      this.displayedItems.forEach(inv => {
        if (!map[inv.cardCode]) map[inv.cardCode] = inv.cardName || "";
      });

      return Object.entries(map).map(([code, name]) => ({
        value: code,
        text : `${code} – ${name}`,
      }));
    },
    ownerOptionsFromDisplay() {
      const map = {};
      this.displayedItems.forEach(inv => {
        const key = inv?.owner || "";              // UID or whatever you store
        if (!key) return;                         // skip blanks
        if (!map[key]) map[key] = inv?.ownerData?.nameFirstTH + " " + inv?.ownerData?.nameLastTH || "-"|| key;
      });
      return Object.entries(map).map(([uid, name]) => ({
        value: uid,
        text : `${name}`,
      }));
    },
    isDuplicate() {
      return (this.selectedDoc?.docId === this.selectedDocIdCopy) && this.selectedDoc?.isDuplicate
    },
    vendorList() {
      return this.selectedCompanyApVendors.map((vendor) => ({
        venCode: vendor.venCode,
        venName: vendor.venName,
        venLabel: vendor.venLabel,
        venBranch: vendor.venBranch,
      }));
    },
    popupTableHeadersFiltered() {
      return this.popupTableHeaders.filter((item) =>
        this.selectedCompanyProductList?.isApAutomateType === 1
          ? true
          : item.type !== "SAP"
      );
    },
    itemsRangeText() {
      const start = (this.currentPage - 1) * this.itemsPerPage + 1;
      const end = Math.min(
        this.currentPage * this.itemsPerPage,
        this.totalItems
      );
      return `${start} - ${end} จาก ${this.totalItems}`;
    },
    formattedPiDate() {
      const date = this.selectedDoc?.docDate
        ? moment(
            this.selectedDoc.docDate.seconds * 1000 || this.selectedDoc.docDate
          )
        : null;

      return date?.isValid() ? date.format("YYYY-MM-DD") : "";
    },
    formattedPiDueDate() {
      const date = this.selectedDoc?.docDueDate
        ? moment(
            this.selectedDoc.docDueDate.seconds * 1000 ||
              this.selectedDoc.docDueDate
          )
        : null;

      return date?.isValid() ? date.format("YYYY-MM-DD") : "";
    },
    formattedPaymentDate() {
      const date = this.selectedDoc?.payment?.paymentDate
        ? moment(
            this.selectedDoc?.payment?.paymentDate.seconds * 1000 ||
              this.selectedDoc?.payment?.paymentDate
          )
        : null;

      return date?.isValid() ? date.format("YYYY-MM-DD") : "";
    },
    formattedVAT() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.VAT);
    },
    formattedSubTotal() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.SubTotal);
    },
    formattedSubTotalSO() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.SubTotalSO);
    },
    formattedDiscount() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.Discount);
    },
    formattedDoctotal() {
      // Format the VAT value using Intl.NumberFormat
      return this.formatNum(this.selectedDoc.Doctotal);
    },
    numPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    areItemsSelected() {
      return this.selectedItems.length > 0;
    },
    isDocUnchanged() {
      return _isEqual(this.selectedDoc, this.selectedDocCopy);
    },
    currentVendor() {
      return this.selectedCompanyAutoDocConfig.find(
        (item) => item.vendorCode === this.$route.params.vendorId
      );
    },
    imageStyle() {
      if (this.isZoomed) {
        return {
          transform: `scale(1.5)`,
          transformOrigin: `${this.mouseX}% ${this.mouseY}%`,
          transition: "transform 0.3s ease-out",
        };
      }
      return {
        transform: "scale(1)",
        transition: "transform 0.3s ease-out",
      };
    },
    docTotalBeforeDis() {
      if (this.selectedDoc.docLine.length > 0) {
        const r = this.selectedDoc.docLine
          .map((item) => Number(item.lineTotal) || 0)
          .reduce((a, b) => a + b, 0)
          ?.toFixed(2);

        return r || "0.00";
      }
      return "0.00";
    },
    docTaxAmount() {
      if (this.selectedDoc.docLine.length > 0) {
        return (
          this.selectedDoc.docLine
            .map((item) => Number(item.taxAmount) || 0)
            .reduce((a, b) => a + b, 0)
            ?.toFixed(2) || "0.00"
        );
      }
      return "0.00";
    },
    docWhtAmount() {
      if (this.selectedDoc.docLine.length > 0) {
        return (
          this.selectedDoc.docLine
            .map((item) => Number(item.whtAmount) || 0)
            .reduce((a, b) => a + b, 0) || "0.00"
        );
      }
      return "0.00";
    },
    docTotalPayment() {
      if (this.selectedDoc.docLine.length > 0) {
        const r = parseFloat(
          Number(
            this.docTotalBeforeDis -
              Number(this.selectedDoc.totalDisAmount) -
              Number(this.docWhtAmount) +
              Number(this.docTaxAmount)
          )
        ).toFixed(2);
        return isNaN(r) ? "0.00" : r || "0.00";
      }
      return "0.00";
    },
    accountRecords() {
       return this.selectedDoc ? this.buildAccountRecords(this.selectedDoc) : [];
    },
    grandTotalBeforeDiscount() {
      return this.purchaseInvoices.reduce((sum, inv) => sum + (Number(inv.totalBeforeDiscount) || 0), 0);
    },
    grandTotalTaxAmount() {
      return this.purchaseInvoices.reduce((sum, inv) => sum + (Number(inv.totalTaxAmount) || 0), 0);
    },
    grandTotalDocTotal() {
      return this.purchaseInvoices.reduce((sum, inv) => sum + (Number(inv.docTotal) || 0), 0);
    },
    grandTotalWhtAmount() {
      return this.purchaseInvoices.reduce((sum, inv) => sum + (Number(inv.totalWhtAmount) || 0), 0);
    },
    grandTotalDebit() {
      return this.purchaseInvoicesWithAccountRecords.reduce((sum, item) => sum + this.getItemTotalDebit(item), 0);
    },
    grandTotalCredit() {
      return this.purchaseInvoicesWithAccountRecords.reduce((sum, item) => sum + this.getItemTotalCredit(item), 0);
    },
    isGrandDebitCreditBalanced() {
      return Math.abs(this.grandTotalDebit - this.grandTotalCredit) < 0.01;
    },
    purchaseInvoicesWithAccountRecords() {
      // Map over the reactive array so this recomputes automatically
      return this.displayedItems.map(inv => ({
        ...inv,
        accountRecords: this.buildAccountRecords(inv),
      }));
    },
    vendorBranch() {
      return this.selectedCompanyApVendors.find(
        (item) => item.venCode === this.selectedDoc.cardCode
      )?.venBranch;
    },
  },
  watch: {
    isShowDetail(newVal) {
    localStorage.setItem("isShowDetail", JSON.stringify(newVal));
  },
    ownerFilter() {
    this.currentPage = 1;
    this.paginate();
  },
    vendorFilter() {
    this.currentPage = 1;   // reset to first page
    this.paginate();
  },
    currentPage() {
      this.paginate();
    },

    selectedDoc() {
      this.selectedDoc.docTotal = this.selectedDoc?.payment?.paymentTotal;
    },

    selectedItems() {
      if (
        this.selectedItems.length === this.displayedItems.length &&
        this.selectedItems.length > 0 &&
        this.displayedItems.length > 0
      ) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },

    $route: {
      handler() {
        this.intPage();
        this.resetSearchConfig();
        this.fetchPurchaseInvoices();
      },
      deep: true,
    },
  },
  mounted() {

    logActivity("page_view", { page_title: "DocumentAP" });
    this.intPage();
    this.fetchPurchaseInvoices();
    window.addEventListener('keydown', this.handleEscKey);

  },
  beforeDestroy() {
    // Unsubscribe from Firestore updates when component is destroyed
    if (this.unsubscribe) {
      this.unsubscribe();
    }

    window.removeEventListener('keydown', this.handleEscKey);
  },
};
</script>

<template>
  <Admin style="background: white">
    <v-main class="wrapper">
      <!-- isLoadingDocs: {{ isLoadingDocs }} -->
      <!-- HI CompanyId:: {{ this.$route.params.companyId }}
      <br/>
      -->

      <!-- firebase.auth().currentUser.uid  -->

      <!-- {{ userCompany?.isDeveloper }} -->

      <!-- payAcctList {{payAcctList}} -->
      <!-- vatList {{vatList}} -->
      <!-- whtList {{whtList}} -->
      <!-- expenseList {{expenseList}} -->
      <!-- selectedCompanyProductList {{selectedCompanyProductList}} -->
      <!-- selectedCompanyProductList {{selectedCompanyProductList?.isApAutomateType}} -->

      <v-container fluid>
        <v-card>
          <!-- Confirmation Dialog for Single Document -->
          <confirm-single-document-dialog
            :is-open="dialogConfirmDocumentOne"
            @update:isOpen="dialogConfirmDocumentOne = $event"
            @confirm="confirmDocumentOne"
          />

          <basic-confirm-dialog
            :is-open="dialogRefreshDocument"
            topic="การดึงข้อมูลอีกครั้ง"
            @update:isOpen="dialogRefreshDocument = $event"
            @confirm="refreshPurchasePdfFile"
          />

          <!-- Confirmation Dialog for Multiple Documents -->
          <confirm-document-dialog
            :is-open="dialogConfirmDocument"
            :selected-items="selectedItems"
            @update:isOpen="dialogConfirmDocument = $event"
            @confirm="confirmDocument"
          />

          <!-- Delete Confirmation Dialog -->
          <confirm-delete-dialog
            :is-open="dialogDelete"
            :docIdLabel="docToDelete?.docId"
            @update:isOpen="dialogDelete = $event"
            @confirm="deleteSelectedItems"
          />

          <div class="table-container">
            <div v-if="vendorId !== ''" class="ma-4">
              <h3 class="tw-text-base">
                <div
                  class="tw-flex tw-items-center tw-gap-2"
                  v-if="currentVendor?.vendorFullName"
                >
                  <img
                    :src="currentVendor?.logo"
                    class="tw-w-8 tw-h-8 tw-object-contain"
                  />
                  {{ currentVendor?.vendorFullName }} - เลขที่ผู้เสียภาษี
                  {{ currentVendor?.taxId }}
                </div>
                <span v-else
                  ><v-icon size="32">mdi-city</v-icon>
                  <v-icon class="mdi-spin">mdi-refresh</v-icon></span
                >
              </h3>
            </div>
            <hr v-if="vendorId !== ''" class="tw-mx-4 tw-pt-2 tw-opacity-10" />
            <div class="pt-8 table-toolbar">
              <v-row class="px-3 pa-0 tw-gap-4">
                <v-col class="tw-flex tw-flex-wrap tw-gap-2 pa-0" cols="auto">
                    <v-btn color="primary" @click="showDetail">
                    <v-icon left>{{ isShowDetail ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                      {{ isShowDetail ? 'ซ่อนรายละเอียด' : 'แสดงรายละเอียด' }}</v-btn>
                    <v-btn color="success" @click="exportDialog = true">
                      <v-icon left>mdi-file-export</v-icon>
                      ส่งออก Excel
                    </v-btn>
                    <v-btn color="red darken-1" dark @click="exportPdfDialog = true">
                      <v-icon left>mdi-file-pdf-box</v-icon>
                      ส่งออก PDF
                    </v-btn>
                </v-col>
                <v-col class="tw-flex pa-0" cols="2">
                    <v-text-field
                      class="ma-0 pa-0 tw-text-sm"
                      label="ค้นหาเลขที่เอกสาร"
                      dense
                      append-icon="mdi-magnify"
                      v-model="searchDocID"
                      @input="(n) => debounceInput(n, null)"
                      outlined
                    ></v-text-field>
               </v-col>
                <v-autocomplete
                    cols="2"
                    v-model="vendorFilter"
                    :items="vendorOptionsFromDisplay"
                    item-text="text"
                    item-value="value"
                    label="กรองตามผู้ขาย"
                    clearable
                    outlined
                    dense
                  />
                  <v-autocomplete
                  cols="2"
                  outlined
                  v-model="ownerFilter"
                  :items="ownerOptionsFromDisplay"
                  item-text="text"
                  item-value="value"
                  label="กรองตามผู้จัดทำ"
                  clearable dense
                />
                <v-col class="pa-0" cols="2">
                  <v-select
                    :menu-props="{ bottom: true, offsetY: true }"
                    v-model="searchStatus"
                    :items="statusOptions"
                    label="สถานะเอกสาร"
                    dense
                    v-on:change="handleStatusSearch"
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="pa-0" cols="4">
                  <date-range-search
                    outline
                    :initial-from-date="searchStartDate"
                    :initial-to-date="searchEndDate"
                    :on-reset="resetDateSearch"
                    :on-search="fetchPurchaseInvoicesByDateRange"
                  />
                </v-col>
              </v-row>
            </div>
            <table class="custom-table tw-text-sm">
              <thead>
                <tr class="tw-bg-light-gray">
                  <th class="tw-text-center tw-border-r tw-border-white" style="width: 60px; min-width: 60px;">
                    ลำดับ
                  </th>
                  <th class="tw-cursor-pointer tw-text-center tw-border-r tw-border-white" @click="sortTable('invoiceNo')">
                    เลขที่เอกสาร
                    <v-icon v-if="sortBy === 'invoiceNo'">{{
                      sortDirection === "asc"
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                  </th>
                  <th class="tw-cursor-pointer tw-text-center tw-border-r tw-border-white" @click="sortTable('docDate')">
                    วันที่เอกสาร
                    <v-icon v-if="sortBy === 'docDate'">{{
                      sortDirection === "asc"
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                  </th>
                  <th class="tw-cursor-pointer tw-border-r tw-border-white tw-text-center" @click="sortTable('cardName')">
                    ชื่อผู้จำหน่าย
                    <v-icon v-if="sortBy === 'cardName'">{{
                      sortDirection === "asc"
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                  </th>
                  <th class="tw-cursor-pointer tw-border-r tw-border-white tw-text-center th-no-wrap" @click="sortTable('docId')">
                    เลขที่เอกสารจากผู้จำหน่าย
                    <v-icon v-if="sortBy === 'docId'">{{
                      sortDirection === "asc"
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                  </th>
                  <th class="tw-text-center tw-border-r tw-border-white ">
                    มูลค่าสินค้า
                  </th>
                  <th class="tw-text-center tw-border-r tw-border-white">
                    VAT
                  </th>
                  <th class="tw-text-center  tw-border-r tw-border-white">รวมทั้งสิ้น</th>
                  <th class="tw-text-center tw-border-r tw-border-white">WHT</th>
                  <th class="tw-border-r tw-text-center tw-border-white">Remark</th>
                  <th class="tw-border-r tw-text-center tw-border-white">สถานะเอกสาร</th>
                  <th class="tw-border-r tw-text-center tw-border-white">ผู้จัดทำ</th>
                </tr>
              </thead>
              <tbody>
                <template      
                v-for="(item, index) in purchaseInvoicesWithAccountRecords"
                >
                <tr
                  :key="index"
                  @click="showDocDetailDialog(item)"
                > 
                  <td class="tw-text-center">
                    {{ index + 1 + (currentPage - 1) * itemsPerPage }}
                  </td>
                      <td
                      >
                        {{ item?.invoiceNo || "-" }}
                      </td>
                  <td>{{ getThaiDate(item.docDate) === "N/A" ? "-"  : getThaiDate(item.docDate)}}</td>
                
                  <td>{{ item?.cardName }}</td>
                  <td>{{ item?.docId || "-" }}</td>
                  <td class="tw-text-right">
                    {{ $formatCurrency(item?.totalBeforeDiscount) }}
                  </td>
                  <td class="tw-text-right">
                    {{ $formatCurrency(item?.totalTaxAmount) }}
                  </td>
                  <td class="tw-text-right">
                    {{ $formatCurrency(item?.docTotal) }}
                  </td>
                  <td class="tw-text-right">{{ $formatCurrency(item?.totalWhtAmount) }}</td>
                  <td >{{ item?.remark }}</td>
                  <td class="tw-text-xs">
                    <v-tooltip
                      top
                      v-if="
                        item.failureMessage !== '' &&
                        item.failureMessage !== 'N/A' &&
                        item.failureMessage
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <div
                          v-on="on"
                          :class="`status-card ${getColorClass(item.status)}`"
                        >
                          {{ getStatusTH(item.status) }}
                        </div>
                      </template>
                      <span>{{ item.failureMessage }}</span>
                    </v-tooltip>
                    <div
                      v-else
                      :class="`status-card ${getColorClass(item.status)}`"
                    >
                      {{ getStatusTH(item.status) }}
                    </div>
                    <v-icon v-if="item?.replaceCount > 3" color="warning">mdi-alert-box-outline</v-icon>
                  </td>
                  <td><v-icon v-if="item?.ownerData?.nameFirstTH">mdi-account-box</v-icon> {{ `${item?.ownerData?.nameFirstTH || "-"} ${item?.ownerData?.nameLastTH || ""}` }}</td>
                </tr>
                <template v-if="isShowDetail">
                  <tr v-for="(record, rIdx) in item?.accountRecords" :key="index + '-rec-' + rIdx" class="detail-sub-row">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{ record?.acctCode }} - {{ record?.acctName }}</td>
                    <td></td>
                    <td class="tw-text-right">{{ $formatCurrency(record?.totalDebit) === "0.00" ? "" : $formatCurrency(record?.totalDebit) }}</td>
                    <td></td>
                    <td class="tw-text-right">{{ $formatCurrency(record?.totalCredit) == "0.00" ? "" : $formatCurrency(record?.totalCredit) }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr :key="index + '-sum'" class="detail-sum-row">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="tw-text-right">รวม</td>
                    <td></td>
                    <td class="tw-text-right" :class="{ 'tw-text-red-600': !isDebitCreditBalanced(item) }">{{ $formatCurrency(getItemTotalDebit(item)) }}</td>
                    <td></td>
                    <td class="tw-text-right" :class="{ 'tw-text-red-600': !isDebitCreditBalanced(item) }">{{ $formatCurrency(getItemTotalCredit(item)) }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </template>
                </template>
              </tbody>
              <tfoot v-if="purchaseInvoices.length > 0">
                <tr class="grand-total-row">
                  <td colspan="5" class="tw-text-center tw-font-bold">รวมทั้งหมด</td>
                  <td class="tw-text-right tw-font-bold">{{ $formatCurrency(grandTotalBeforeDiscount) }}</td>
                  <td class="tw-text-right tw-font-bold">{{ $formatCurrency(grandTotalTaxAmount) }}</td>
                  <td class="tw-text-right tw-font-bold">{{ $formatCurrency(grandTotalDocTotal) }}</td>
                  <td class="tw-text-right tw-font-bold">{{ $formatCurrency(grandTotalWhtAmount) }}</td>
                  <td class="tw-text-right tw-font-bold">Debit: <span :class="{ 'tw-text-red-600': !isGrandDebitCreditBalanced }">{{ $formatCurrency(grandTotalDebit) }}</span></td>
                  <td class="tw-text-right tw-font-bold">Credit: <span :class="{ 'tw-text-red-600': !isGrandDebitCreditBalanced }">{{ $formatCurrency(grandTotalCredit) }}</span></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
            <div
              v-if="purchaseInvoices.length === 0 && !isLoadingDocs"
              class="tw-text-center tw-w-full tw-opacity-80 tw-py-40"
            >
              <h2>ไม่พบเอกสารที่ต้องการ</h2>
            </div>
            <v-progress-linear
              indeterminate
              color="green"
              :active="isLoadingDocs"
            ></v-progress-linear>
          </div>
          <!-- Pagination Controls -->
        </v-card>
        <v-row justify="start" class="tw-my-4">
          <div class="tw-px-4">
            {{ itemsRangeText }}
          </div>
          <v-spacer />
          <v-pagination
            v-model="currentPage"
            :length="numPages"
            :total-visible="6"
            @input="paginate"
          ></v-pagination>
          <v-spacer />
        </v-row>
      </v-container>
     

      <!-- Docline Form Dialog -->
      <docline-form-dialog
        :isOpen="isDoclineDialogOpen"
        :docline="doclineToEdit"
        :expenseList="expenseList"
        :vatList="vatList"
        :whtList="whtList"
        :isEditMode="isEditModeDocline"
        :companyID="companyId"
        :cardCode="selectedDoc?.cardCode || ''"
        @update:isOpen="isDoclineDialogOpen = $event"
        @save="handleSaveDocline"
      />
    </v-main>

    <v-snackbar
      timeout="2500"
      v-model="snackbar.isShow"
      :color="snackbar.color"
      top
    >
      <v-icon v-if="snackbar.icon" left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.msg }}
    </v-snackbar>

    <v-dialog v-model="exportDialog" persistent max-width="450px">
      <v-form ref="form">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-file-export</v-icon>
            <b>ส่งออกข้อมูล Excel</b>
          </v-card-title>
          <v-card-text class="tw-pb-0">

            <!-- Date Mode -->
            <div class="tw-mb-3">
              <div class="tw-text-sm tw-font-bold tw-mb-1">ช่วงเวลา</div>
              <v-radio-group v-model="exportDateMode" row dense class="tw-mt-0">
                <v-radio label="ข้อมูลทั้งหมด" value="all"></v-radio>
                <v-radio label="เลือกช่วงเวลา" value="range"></v-radio>
              </v-radio-group>
            </div>

            <!-- Date Range Pickers (shown only when range mode) -->
            <template v-if="exportDateMode === 'range'">
              <v-menu
                v-model="menuDatePickerStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    v-model="dateExportStart"
                    label="วันที่เอกสารเริ่มต้น"
                    append-icon="mdi-calendar"
                    persistent-placeholder
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateExportStart"
                  @input="menuDatePickerStart = false"
                ></v-date-picker>
              </v-menu>
              <v-menu
                v-model="menuDatePickerEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    v-model="dateExportEnd"
                    persistent-placeholder
                    label="วันที่เอกสารสิ้นสุด"
                    append-icon="mdi-calendar"
                    :disabled="!dateExportStart"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateExportEnd"
                  :allowed-dates="
                    (date) => new Date(date) >= new Date(dateExportStart)
                  "
                  @input="menuDatePickerEnd = false"
                ></v-date-picker>
              </v-menu>
            </template>

            <!-- Status Filter -->
            <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="exportDocStatus"
              :items="statusOptions"
              label="สถานะเอกสาร"
              outlined
              dense
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="cancelExportDocs">
              <v-icon left>mdi-close-circle-outline</v-icon>
              <b>ยกเลิก</b>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="#6ec39b"
              type="button"
              class="btn-submit"
              :disabled="exportDateMode === 'range' && (!dateExportStart || !dateExportEnd)"
              :loading="isExporting"
              @click="exportDocs"
            >
              <v-icon left>mdi-microsoft-excel</v-icon>
              <b>ส่งออก Excel</b>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="exportPdfDialog" persistent max-width="450px">
      <v-form ref="formPdf">
        <v-card>
          <v-card-title>
            <v-icon left color="red">mdi-file-pdf-box</v-icon>
            <b>ส่งออกข้อมูล PDF</b>
          </v-card-title>
          <v-card-text class="tw-pb-0">
            <div class="tw-mb-3">
              <div class="tw-text-sm tw-font-bold tw-mb-1">ช่วงเวลา</div>
              <v-radio-group v-model="exportPdfDateMode" row dense class="tw-mt-0">
                <v-radio label="ข้อมูลทั้งหมด" value="all"></v-radio>
                <v-radio label="เลือกช่วงเวลา" value="range"></v-radio>
              </v-radio-group>
            </div>
            <template v-if="exportPdfDateMode === 'range'">
              <v-menu
                v-model="menuPdfDatePickerStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    v-model="datePdfExportStart"
                    label="วันที่เอกสารเริ่มต้น"
                    append-icon="mdi-calendar"
                    persistent-placeholder
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="datePdfExportStart"
                  @input="menuPdfDatePickerStart = false"
                ></v-date-picker>
              </v-menu>
              <v-menu
                v-model="menuPdfDatePickerEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    v-model="datePdfExportEnd"
                    persistent-placeholder
                    label="วันที่เอกสารสิ้นสุด"
                    append-icon="mdi-calendar"
                    :disabled="!datePdfExportStart"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="datePdfExportEnd"
                  :allowed-dates="
                    (date) => new Date(date) >= new Date(datePdfExportStart)
                  "
                  @input="menuPdfDatePickerEnd = false"
                ></v-date-picker>
              </v-menu>
            </template>
            <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="exportPdfDocStatus"
              :items="statusOptions"
              label="สถานะเอกสาร"
              outlined
              dense
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="cancelExportPdf">
              <v-icon left>mdi-close-circle-outline</v-icon>
              <b>ยกเลิก</b>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="red darken-1"
              type="button"
              class="btn-submit"
              :disabled="exportPdfDateMode === 'range' && (!datePdfExportStart || !datePdfExportEnd)"
              :loading="isExportingPdf"
              @click="exportPdf"
            >
              <v-icon left>mdi-file-pdf-box</v-icon>
              <b>ส่งออก PDF</b>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </Admin>
</template>

<style lang="scss" scoped>
* {
  --warning-color: rgb(255, 178, 76);
  --warning-bg-color: rgb(255, 178, 77, 0.2);
  --error-color: rgb(173, 15, 1);
  --error-bg-color: rgb(173, 15, 1, 0.2);
  --pending-color: rgb(97, 163, 255);
  --pending-bg-color: rgba(97, 163, 255, 0.2);
  --posting-color: rgb(159, 152, 255);
  --posting-bg-color: rgba(159, 152, 255, 0.2);
  --fetching-color: #777a82;
  --fetching-bg-color: rgba(119, 122, 130, 0.2);
  --new-color: #4794eb;
  --new-bg-color: rgba(71, 148, 235, 0.2);
  --text-color: #ffffff;
  --success-color: #0fb45f;
  --success-bg-color: rgba(15, 180, 95, 0.2);
}

.warning-border {
  ::v-deep fieldset {
    border-color: orange !important;
    border-width: 2px !important;
  }
}

.errorBox {
  color: red;
  border: 2px solid red;
  background: white;
}

.duppBox {
  color: rgb(241, 157, 0);
  border: 2px solid rgb(241, 157, 0);
  background: white;
  font-weight: bold;
}

.duppBox p{
  color: rgb(241, 157, 0);
}

.errorBox:hover {
  animation: none;
}


.custom-button {
  cursor: pointer;
  /* border: 2px solid red; */
  padding: 0.5rem 1rem;
}

.custom-button:active {
  opacity: 50%;
}

.error-color {
  color: var(--error-color);
  background-color: var(--error-bg-color);
  display: inline-block;
}

.success-color {
  color: var(--success-color);
  background-color: var(--success-bg-color);
  display: inline-block;
}

.warning-color {
  color: var(--warning-color);
  background-color: var(--warning-bg-color);
  display: inline-block;
}

.fetching-color {
  color: var(--fetching-color);
  background-color: var(--fetching-bg-color);
  display: inline-block;
}

.pending-color {
  color: var(--pending-color);
  background-color: var(--pending-bg-color);
  display: inline-block;
}
.new-color {
  color: var(--new-color);
  background-color: var(--new-bg-color);
  display: inline-block;
}

.posting-color {
  color: var(--posting-color);
  background-color: var(--posting-bg-color);
  display: inline-block;
}

.status-card {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  max-width: 200px;
}
.status-card-dialogue {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
}
/* Additional styling for the table */
.table-container {
  width: 100%; /* Adjust the width as needed */
  overflow-x: auto;

  td,
  th {
    white-space: nowrap;
  }
}

.table-container-detail {
  width: 100%; /* Adjust the width as needed */
  border: 2px solid red;
  overflow: hidden;
}

.customer-table-detail {
  width: calc(100% - 2.7rem);
  /* border: 2px solid red; */
}

/* Styling for table headers */
.customer-table-detail th {
  padding: 10px;
  text-align: left;
}

/* Styling for table cells */
.customer-table-detail td {
  padding: 10px;
  height: 40px;
  border: 1px solid rgba(182, 182, 182, 0.528);
}

/* Styling for table rows */
.customer-table-detail tbody tr {
  padding: 10px; /* Add padding to each row */
}
.customer-table-detail tbody {
  border-bottom: 2px solid rgb(182, 182, 182);
}
.customer-table-detail tbody:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}
.customer-table-detail tbody:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

/* ---------------------- */

.table-toolbar {
  padding: 1rem;
}

.custom-table {
  border-collapse: collapse;
  width: 100%; /* Make table width 100% of container */
  overflow: hidden;
}

/* Styling for table headers */
.custom-table th {
  padding: 0 10px;
  text-align: left;
  white-space: nowrap; /* Prevents text wrapping */
  height: 60px;
  border-bottom: 1px solid rgb(182, 182, 182);
  font-weight: 400;
}

/* Styling for table cells */
.custom-table td {
  padding: 0 10px;
  text-align: left;
  white-space: nowrap; /* Prevents text wrapping */
}

/* Styling for table rows */
.custom-table tbody tr {
  border-bottom: 1px solid #e6e6e6;
  padding: 0 10px; /* Add padding to each row */
  height: 3rem; /* Add height to each row */
}

.custom-table tbody .tr-no-border {
  cursor: default !important;
  border-bottom: 0px;
  padding: 0 10px; /* Add padding to each row */
  height: 3rem; /* Add height to each row */
}

.detail-row td {
  color: #000000 !important;
  font-size: 0.875rem !important;
  font-weight: 400 !important;
}

.sum-row td {
  font-weight: 400 !important;
  border-top: 1px solid #999 !important;
}

.custom-table tbody tr.detail-sub-row {
  border-bottom: none !important;
  height: 2.5rem;
}

// .custom-table tbody tr.detail-sum-row {
//   border-bottom: 2px solid #333 !important;
//   height: 2.5rem;
// }

.custom-table tbody tr.detail-sum-row > td {
  border-top: 1px solid #e6e6e6;
}

.grand-total-row {
  background-color: #e8e8e8 !important;
  border-top: 2px solid #333 !important;
}

.grand-total-row td {
  padding: 8px 10px !important;
  font-size: 0.875rem !important;
}

.custom-table tbody tr:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}

.custom-table tbody tr:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

.custom-dialogue {
  position: fixed;
  z-index: 99;
  padding: 1.5rem;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  transition: all 0.3s;
}

.custom-dialogue-content-wrapper {
  padding: 1rem;
  background-color: #f9f9f9;
  border-radius: 1rem;
  height: 100%;
  width: 100%;
  /* border: 5px solid green; */
}

.dialog-header-wrapper {
  /* border: 2px solid green; */
  height: 2.7rem;
}

/* Default styles for .dialog-content-wrapper */
.dialog-content-wrapper {
  /* border: 2px solid red; */
  display: flex;
  padding: 8px 0px;
  height: calc(100% - 2.7rem * 2);
  width: 100%;
}

.dialog-content-left {
  /* border: 2px solid red; */
  width: 35%;
}

.dialog-content-right {
  /* border: 2px solid green; */
  min-width: 65%;
  flex: 1;
  box-sizing: border-box;
}

@media (max-width: 947px) {
  .dialog-content-wrapper {
    flex-direction: column;
  }

  .dialog-content-left {
    width: 100%;
    height: 40%;
    max-width: 40%; /* Ensures left side doesn't exceed 50% width */
  }

  .dialog-content-right {
    /* border: 2px solid green; */
    height: calc(60% - 2.7rem);
  }
}

.dialog-footer-wrapper {
  /* border: 2px solid blue; */
  height: 2.7rem;
}

.image-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.image-container:hover {
  cursor: zoom-in;
}

.invoice-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: all 0.3s;
}

.td-copy:hover {
  background-color: #f2f2f2;
}

.td-copy:active {
  background-color: #e2dfdf;
}

.popup-table-wrapper {
  overflow-x: auto; /* Allows horizontal scrolling if the table overflows */
  width: 100%; /* Ensures the table takes up the full width of the left-side container */
}

/* WebKit Browsers (Chrome, Safari, Edge) */
.popup-table-wrapper::-webkit-scrollbar {
  height: 10px; /* Makes the scrollbar even thinner */
}

.popup-table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1; /* Optional: scrollbar track color */
}

.popup-table-wrapper::-webkit-scrollbar-thumb {
  background: #b8b8b8; /* Scrollbar thumb color */
  border-radius: 10px; /* Makes the scrollbar thumb more rounded */
}

.popup-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #616161; /* Changes thumb color on hover */
}

.popup-table {
  white-space: nowrap; /* Prevents table content from wrapping */
  width: 100%; /* Ensures the table spans the full width of its container */
  border-collapse: collapse;
}

.popup-table th,
.popup-table td {
  padding: 10px; /* Optional: for table cell padding */
  border: 1px solid #ddd; /* Optional: for table cell borders */
  font-weight: 500;
}

.warning-td {
  border: 2px solid red !important;
}

@media screen and (max-width: 947px), screen and (orientation: portrait) {
  .dialog-content-wrapper {
    flex-direction: column;
  }

  .dialog-content-left {
    width: 100%;
    height: 40%;
    margin-bottom: 1rem;
  }

  .dialog-content-right {
    width: 100%;
    height: auto;
    overflow-y: auto;
  }
}

</style>
